import "./customVideoPlayer.css";
import forwardIcon from "../../../assets/img/icon/tenF.png";
import backwardIcon from "../../../assets/img/icon/tenB.png";
import playIcon from "../../../assets/img/icon/play-solid.svg"
import pauseIcon from "../../../assets/img/icon/pause-solid.svg"
import volumeOn from "../../../assets/img/icon/volume-high-solid.svg"
import volumeOff from "../../../assets/img/icon/volume-xmark-solid.svg"
import { Buffer } from 'buffer';

const Controls = ({
  onPlayPause,
  playing,
  onRewind,
  onForward,
  played,
  onSeek,
  onSeekMouseUp,
  onVolumeChangeHandler,
  onVolumeSeekUp,
  volume,
  mute,
  onMute,
  duration,
  currentTime,
  onMouseSeekDown,
  controlRef,
  toggleFullScreen,
  buffer,
  rates,
  onPlayBackRateChange,
  playRate
}) => {

  // console.log("buffer" , buffer);
  return (
    <div className="control_Container" ref={controlRef}>
      <div className="mid__container">
        {buffer ? <span className="loader"></span> : 
        (<>
          <div
            onClick={() => onForward()}
            style={{ cursor: "pointer" }}
            className="tenSec-backward m-2  text-white "
          >
            <img src={forwardIcon} alt="" />
          </div>
          <div className="icon__btn middle" onClick={(e) => onPlayPause(e)}>
            <img src={playing ? pauseIcon : playIcon} alt="" />
          </div>
          <div
            onClick={() => onRewind()}
            style={{ cursor: "pointer" }}
            className="tenSec-forward m-2 text-white "
          >
            <img src={backwardIcon} alt="" />
          </div>
        </>)}
      </div>
      <div className="bottom__container d-flex align-items-center justify-content-center">
        <div className="slider__container">
          <input
            type="range"
            min={0}
            max={100}
            value={played * 100}
            onMouseDown={onMouseSeekDown}
            onChange={onSeek}
            onMouseUp={onSeekMouseUp} // This event is triggered after the user releases the slider handle
          />
        </div>
        <div className="control__box">
          <div className="inner__controls">
            <div className="icon__btn bottom" onClick={onPlayPause}>
              <img src={playing ? pauseIcon : playIcon} alt="" />
            </div>

            <div className="video-time d-flex align-items-center justify-content-center">
              <span>{currentTime}</span> / <span>{duration}</span>
            </div>
          </div>
          <div className="d-flex h-100 w-100 gap-2 align-items-center justify-content-end">
            <div className="playBackRate-container">
              <select value={playRate} id="playBackRates" onChange={onPlayBackRateChange}>
                {rates.map(rate => (
                  <option value={rate}>x{rate}</option>
                ))}
              </select>
            </div>
            <div className="icon__btn" onClick={onMute}>
              <img src={mute ? volumeOff : volumeOn} alt="" />
            </div>
            <div className="d-flex align-items-center h-100">
              <input
                type="range"
                min={0}
                max={100}
                value={volume * 100}
                onChange={onVolumeChangeHandler}
                onMouseUp={onVolumeSeekUp}
              />
            </div>
            <div onClick={toggleFullScreen} className="fullScreen-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path d="M32 32C14.3 32 0 46.3 0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V352zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H320zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V352z" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Controls;
